<template>
	<!-- 分配用户弹窗 -->
	<div class="distribution">
		<u-dialog :title="$t('modal.txt1')" width="60%" top="5vh" :visible.sync="customVisible" @confirm="confirm">
			<el-table  ref="table" :data="dataList" @selection-change="handleSelectionChange" @row-click="rowClick" >
				<el-table-column :label="$t('modal.txt2')" type="selection" width="50">
				</el-table-column>
				<el-table-column :label="$t('modal.txt3')">
					<template slot-scope="scope">
						<span>{{scope.row.userName?scope.row.userName:'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('modal.txt4')">
					<template slot-scope="scope">
						<span>{{scope.row.realName?scope.row.realName:'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('modal.txt5')">
					<template slot-scope="scope">
						<span>{{scope.row.mobile?scope.row.mobile:'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('modal.txt6')">
					<template slot-scope="scope">
						<span>{{scope.row.companyName?scope.row.companyName:'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('modal.txt7')">
					<template slot-scope="scope">
						<span v-if="scope.row.roleList[0]">{{scope.row.roleList[0].roleName}}</span>
						<span v-if="scope.row.roleList[1]">,{{scope.row.roleList[1].roleName}}</span>
						<span v-if="scope.row.roleList.length>2">...</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="table-footer tablePagination" v-show="total>0">
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="queryInfo.page"
				:page-sizes="[10, 20]"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
				</el-pagination>
			</div>     
		</u-dialog>
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		props: {
			visible: Boolean,
		},
		components: {
		},
		data() {
			return {
				customVisible: false,
				dataList: [],
				total: 0,
				multipleSelection:[],
				queryInfo: {
					pageNum: 0,
          			size: 50,
          			search: ''
				},
			};
		},
		watch: {
			visible(val) {
				if(val) {
					this.loadData();
				}
				this.customVisible = val;
			},
			customVisible(value) {
				this.$emit("update:visible", value);
			},
		},
		methods: {
			async loadData(){
				const { data: res } = await this.$http.post("/user/info/list?"+qs.stringify(this.queryInfo));
				if(!res.success){
					return this.$message.error(res.message);
				}
				this.dataList = res.result.data;
				this.total = res.result.total;
				console.log(this.total,'this.total');
			},
			rowClick(row) {
				this.$refs.table.toggleRowSelection(row);
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			confirm() {
				if(!this.multipleSelection.length) { 
					this.$message.warning(this.$t('modal.txt8'),)
					this.$emit('update:visible', true)
					return 
				}
				this.$emit("confirm", this.multipleSelection);
			},
		// 页面切换
		handleCurrentChange(page) {
			this.queryInfo.pageNum = page;
			this.loadData();
		},
		handleSizeChange(size){
			this.queryInfo.size = size;
			this.loadData();
		},
	},
};
</script>
<style lang="less" scoped>
	.distribution{
		/deep/ .el-table{
			height: 400px;
			overflow-y: scroll;
		}
	}
</style>


